import { Injectable } from "@angular/core";

import {
  ApiService,
  HttpQueryService,
  LocaleService,
} from "src/app/core/services";

import { IVendor } from "src/app/commons/ITypes";
import { IQueryParams } from "src/app/core/ITypes";
import { VendorType } from "src/app/layout/vendor/entity";
import { vendorFormSchema } from "src/app/layout/vendor/write/schema";
import { isNumeric } from "src/app/commons/utils";

@Injectable()
export class VendorService {
  constructor(
    private apiService: ApiService,
    private httpQueryService: HttpQueryService,
    private localeService: LocaleService
  ) {}

  getFormSchema() {
    try {
      const { status, result } = vendorFormSchema;

      if (status === 200 && result && result.properties) {
        const components = result.properties.components;

        return components;
      }
    } catch (error) {
      throw error;
    }
  }

  async save(data: IVendor) {
    try {
      const { id: vendorID, ...payload } = data;
      const payloadEntity = {
        properties: payload,
        id: vendorID || undefined,
      };
      let requestUrl = "/vendor/",
        response,
        responseMsg;

      if (data.id) {
        response = await this.apiService
          .patch(payloadEntity, requestUrl)
          .toPromise();
        responseMsg = this.localeService.trans("NOTIFY.NT002");
      } else {
        response = await this.apiService
          .post(payloadEntity, requestUrl)
          .toPromise();
        responseMsg = this.localeService.trans("NOTIFY.NT001");
      }

      const { status, result } = response;

      if (status === 200 && result) {
        const props = result?.properties;
        if (props) {
          props["id"] = result.id;
        }
        return {
          data: props,
          message: responseMsg,
        };
      }
    } catch (error) {
      throw error;
    }
  }

  async getVendors(queryParams: IQueryParams) {
    try {
      const limit = queryParams.limit;
      const skip = queryParams.offset;
      const searchTerm = queryParams.search?.trim();
      const search = Object.assign(
        {},
        isNumeric(searchTerm) ? { code: searchTerm } : { name: searchTerm }
      );
      const direction = queryParams.direction;
      const order = queryParams.order;
      const filter = queryParams.filter;
      const querySet = { limit, skip, direction, order, search, filter };
      const queryString = this.httpQueryService.serialize(querySet);

      let apiEndpoint = `/vendor?${queryString}`;

      const { status, result, meta } = await this.apiService
        .get(apiEndpoint)
        .toPromise();

      if (status === 200 && result) {
        const r = result.map((r) => {
          const props = r.properties;

          props.titleType = VendorType.findTitle(props.type);

          return { id: r.id, ...props };
        });

        return { result: r, meta };
      }
    } catch (error) {
      throw error;
    }
  }

  async getVendor(id: string) {
    try {
      const { status, result } = await this.apiService
        .getById(null, `/${id}`)
        .toPromise();

      if (status === 200 && result) {
        const props = result.properties;
        return props;
      }
    } catch (error) {
      throw error;
    }
  }

  async isVendorExist(vendor: {
    key: string;
    value: number | string;
    id?: string;
  }): Promise<{ status: boolean; msg: string }> {
    try {
      const params = {
        limit: 50,
        filter: [{ key: vendor.key, value: vendor.value }],
      };

      const { result } = await this.getVendors(params);
      const vendors = result || [];
      let status = result.length > 0;
      let msgLiteral = this.localeService.trans("ERRORS.ER003");

      if (status) {
        let foundVendor = vendors.find((item) => {
          return item[vendor.key] == vendor.value;
        });

        //It will trigger in [UPDATE] case where id is existed
        if (foundVendor && vendor.id) {
          if (foundVendor.id == vendor.id) {
            return { status: false, msg: "" };
          }
        }

        let validateMsg = {
          vendorId: { value: foundVendor, label: "ID" },
          code: { value: foundVendor, label: "Code" },
        };

        const selectedMsg = validateMsg[vendor.key];

        if (selectedMsg.value) {
          msgLiteral = msgLiteral.replace(
            "{msg}",
            `${selectedMsg.label} : ${selectedMsg.value[vendor.key]}`
          );
        }
      }

      return { status, msg: status ? msgLiteral : "" };
    } catch (e) {
      return { status: false, msg: "" };
    }
  }
}
